// extracted by mini-css-extract-plugin
module.exports = {"root":"ZAsIpq3LsdHWARhGI0t_"};